import dateFormat from "dateformat";
import LanguagePack from "../../../../../shared/lib/html5-software-library/src/ranj/language/LanguagePack";
import Anchor from "../../../../../shared/lib/html5-software-library/src/ranj/layout/Anchor";
import GameEvent from "../../../../../shared/src/ranj/app/core/GameEvent";
import GameModel from "../model/GameModel";
import AbstractAccuracyScreenMediator from "./AbstractAccuracyScreenMediator";

export default class EndScreenMediator extends AbstractAccuracyScreenMediator {

    /**
     * 
     * @param {createjs.DisplayObject} target 
     * @param {soma.EventDispatcher} dispatcher 
     * @param {LanguagePack} languagePack 
     * @param {GameModel} gameModel 
     */
    constructor(target, dispatcher, languagePack, layoutManager, soundManager, gameModel, saveModel, gameAssets) {
        super(target, dispatcher, languagePack, layoutManager, soundManager, gameModel, saveModel, gameAssets);

        this.createButton(this._target.button, this._handleButtonClick.bind(this), this.getText("end.button"));
    }

    initialize() {
        super.initialize();

        this._target.titleTextfield.text = this.getText("end.title");
        this._target.bodyTextfield.text = this.getText("end.body");

        this.anchorObject(this._target.titleTextfield, Anchor.T);
        this.anchorObject(this._target.bodyTextfield, Anchor.T);
        this.anchorObject(this._target.button, Anchor.B);
    }

    _handleButtonClick(e) {
        this.dispatch(GameEvent.EXIT);
    }
};
